/* eslint-disable  */
export const videoPlayCountershyderabadiVideoHeadings = [
  'Date',
  'Hyderabadi Video likes',
  'Hyderabadi Video shares',
  'Hyderabadi Video downloads',
  'Hyderabadi Video views',
  'Hyderabadi Video follows',
  'Guest Hyderabadi Video likes',
  'Guest Hyderabadi Video shares',
  'Guest Hyderabadi Video downloads',
  'Guest Hyderabadi Video views',
  'Guest Hyderabadi Video follows',
  'Day',
]

export const contentTypesForTags = [
  { Type: 'person', Mode: 'TFIDB', name: 'Persons' },
  { Type: 'movies', Mode: 'TFIDB', name: 'Movies' },
  { Type: 'personGalleryImages', Mode: 'TFIDB', name: 'Images(Person)' },
  { Type: 'personGalleryVideos', Mode: 'TFIDB', name: 'Videos(Person)' },
  { Type: 'person', Mode: 'Admin', name: 'Persons(Admin)' },
  { Type: 'movies', Mode: 'Admin', name: 'Movies(Admin)' },
]

export const videoPlayCountersonlyMusicVideoHeadings = [
  'Date',
  'OnlyMusic Video likes',
  'OnlyMusic Video shares',
  'OnlyMusic Video downloads',
  'OnlyMusic Video views',
  'OnlyMusic Video follows',
  'Guest OnlyMusic Video likes',
  'Guest OnlyMusic Video shares',
  'Guest OnlyMusic Video downloads',
  'Guest OnlyMusic Video views',
  'Guest OnlyMusic Video follows',
  'Day',
]
export const videoPlayCountersenglishVideoHeadings = [
  'Date',
  'English Video likes',
  'English Video shares',
  'English Video downloads',
  'English Video views',
  'English Video follows',
  'Guest English Video likes',
  'Guest English Video shares',
  'Guest English Video downloads',
  'Guest English Video views',
  'Guest English Video follows',
  'Day',
]
export const teluguContentHeadingsForJobs = [
  'Date',
  'Telugu Content Jobs likes',
  'Telugu Content Jobs shares',
  'Telugu Content Jobs views',
  'Guest Telugu Content Jobs likes',
  'Guest Telugu Content Jobs shares',
  'Guest Telugu Content Jobs views',
  'Day',
]
export const englishContentHeadingsForJobs = [
  'Date',
  'English Content Jobs likes',
  'English Content Jobs shares',
  'English Content Jobs views',
  'Guest English Content Jobs likes',
  'Guest English Content Jobs shares',
  'Guest English Content Jobs views',
  'Day',
]
export const videoPlayCountersHeadings = [
  'Date',
  'Day',
  'Telugu Video likes',
  'Telugu Video shares',
  'Telugu Video downloads',
  'Telugu Video views',
  'Telugu Video follows',
  'Guest Telugu Video likes',
  'Guest Telugu Video shares',
  'Guest Telugu Video downloads',
  'Guest Telugu Video views',
  'Guest Telugu Video follows',
  'Hindi Video likes',
  'Hindi Video shares',
  'Hindi Video downloads',
  'Hindi Video views',
  'Hindi Video follows',
  'Guest Hindi Video likes',
  'Guest Hindi Video shares',
  'Guest Hindi Video downloads',
  'Guest Hindi Video views',
  'Guest Hindi Video follows',
  'English Video likes',
  'English Video shares',
  'English Video downloads',
  'English Video views',
  'English Video follows',
  'Guest English Video likes',
  'Guest English Video shares',
  'Guest English Video downloads',
  'Guest English Video views',
  'Guest English Video follows',
  'OnlyMusic Video likes',
  'OnlyMusic Video shares',
  'OnlyMusic Video downloads',
  'OnlyMusic Video views',
  'OnlyMusic Video follows',
  'Guest OnlyMusic Video likes',
  'Guest OnlyMusic Video shares',
  'Guest OnlyMusic Video downloads',
  'Guest OnlyMusic Video views',
  'Guest OnlyMusic Video follows',
  'Hyderabadi Video likes',
  'Hyderabadi Video shares',
  'Hyderabadi Video downloads',
  'Hyderabadi Video views',
  'Hyderabadi Video follows',
  'Guest Hyderabadi Video likes',
  'Guest Hyderabadi Video shares',
  'Guest Hyderabadi Video downloads',
  'Guest Hyderabadi Video views',
  'Guest Hyderabadi Video follows',
  'Telugu Content Story likes',
  'Telugu Content Story shares',
  'Telugu Content Story views',
  'Telugu Content Story Watch Analytics',
  'Guest Telugu Content Story likes',
  'Guest Telugu Content Story shares',
  'Guest Telugu Content Story views',
  'Guest Telugu Content Story Watch Analytics',
  'Telugu Content CoverStory likes',
  'Telugu Content CoverStory shares',
  'Telugu Content CoverStory views',
  'Telugu Content CoverStory Watch Analytics',
  'Guest Telugu Content CoverStory likes',
  'Guest Telugu Content CoverStory shares',
  'Guest Telugu Content CoverStory views',
  'Guest Telugu Content CoverStory Watch Analytics',
  'Telugu Content Mcq likes',
  'Telugu Content Mcq shares',
  'Telugu Content Mcq views',
  'Telugu Content Mcq Watch Analytics',
  'Guest Telugu Content Mcq likes',
  'Guest Telugu Content Mcq shares',
  'Guest Telugu Content Mcq views',
  'Guest Telugu Content Mcq Watch Analytics',
  'Telugu Content Poll likes',
  'Telugu Content Poll shares',
  'Telugu Content Poll views',
  'Telugu Content Poll Watch Analytics',
  'Guest Telugu Content Poll likes',
  'Guest Telugu Content Poll shares',
  'Guest Telugu Content Poll views',
  'Guest Telugu Content Poll Watch Analytics',
  'Hindi Content Story likes',
  'Hindi Content Story shares',
  'Hindi Content Story views',
  'Hindi Content Story Watch Analytics',
  'Guest Hindi Content Story likes',
  'Guest Hindi Content Story shares',
  'Guest Hindi Content Story views',
  'Guest Hindi Content Story Watch Analytics',
  'Hindi Content CoverStory likes',
  'Hindi Content CoverStory shares',
  'Hindi Content CoverStory views',
  'Hindi Content CoverStory Watch Analytics',
  'Guest Hindi Content CoverStory likes',
  'Guest Hindi Content CoverStory shares',
  'Guest Hindi Content CoverStory views',
  'Guest Hindi Content CoverStory Watch Analytics',
  'Hindi Content Mcq likes',
  'Hindi Content Mcq shares',
  'Hindi Content Mcq views',
  'Hindi Content Mcq Watch Analytics',
  'Guest Hindi Content Mcq likes',
  'Guest Hindi Content Mcq shares',
  'Guest Hindi Content Mcq views',
  'Guest Hindi Content Mcq Watch Analytics',
  'Hindi Content Poll likes',
  'Hindi Content Poll shares',
  'Hindi Content Poll views',
  'Hindi Content Poll Watch Analytics',
  'Guest Hindi Content Poll likes',
  'Guest Hindi Content Poll shares',
  'Guest Hindi Content Poll views',
  'Guest Hindi Content Poll Watch Analytics',
  'English Content Story likes',
  'English Content Story shares',
  'English Content Story views',
  'English Content Story Watch Analytics',
  'Guest English Content Story likes',
  'Guest English Content Story shares',
  'Guest English Content Story views',
  'Guest English Content Story Watch Analytics',
  'English Content CoverStory likes',
  'English Content CoverStory shares',
  'English Content CoverStory views',
  'English Content CoverStory Watch Analytics',
  'Guest English Content CoverStory likes',
  'Guest English Content CoverStory shares',
  'Guest English Content CoverStory views',
  'Guest English Content CoverStory Watch Analytics',
  'English Content Mcq likes',
  'English Content Mcq shares',
  'English Content Mcq views',
  'English Content Mcq Watch Analytics',
  'Guest English Content Mcq likes',
  'Guest English Content Mcq shares',
  'Guest English Content Mcq views',
  'Guest English Content Mcq Watch Analytics',
  'English Content Poll likes',
  'English Content Poll shares',
  'English Content Poll views',
  'English Content Poll Watch Analytics',
  'Guest English Content Poll likes',
  'Guest English Content Poll shares',
  'Guest English Content Poll views',
  'Guest English Content Poll Watch Analytics',
]
export const videoPlayCountersContentHeadings = [
  'Date',
  'No Of Articles Published',
  'Active Users',
  'Telugu Content Story likes',
  'Telugu Content Story shares',
  'Telugu Content Story views',
  'Telugu Content Story Watch Analytics',
  'Guest Telugu Content Story likes',
  'Guest Telugu Content Story shares',
  'Guest Telugu Content Story views',
  'Guest Telugu Content Story Watch Analytics',
  'Telugu Content ShortByte likes',
  'Telugu Content ShortByte shares',
  'Telugu Content ShortByte views',
  'Guest Telugu Content ShortByte likes',
  'Guest Telugu Content ShortByte shares',
  'Guest Telugu Content ShortByte views',
  'Telugu Content liveNews likes',
  'Telugu Content liveNews shares',
  'Telugu Content liveNews views',
  'Guest Telugu Content liveNews likes',
  'Guest Telugu Content liveNews shares',
  'Guest Telugu Content liveNews views',
  'Telugu Content CoverStory likes',
  'Telugu Content CoverStory shares',
  'Telugu Content CoverStory views',
  'Telugu Content CoverStory Watch Analytics',
  'Guest Telugu Content CoverStory likes',
  'Guest Telugu Content CoverStory shares',
  'Guest Telugu Content CoverStory views',
  'Guest Telugu Content CoverStory Watch Analytics',
  'Telugu Content Mcq likes',
  'Telugu Content Mcq shares',
  'Telugu Content Mcq views',
  'Telugu Content Mcq Watch Analytics',
  'Guest Telugu Content Mcq likes',
  'Guest Telugu Content Mcq shares',
  'Guest Telugu Content Mcq views',
  'Guest Telugu Content Mcq Watch Analytics',
  'Telugu Content SlideShow likes',
  'Telugu Content SlideShow shares',
  'Telugu Content SlideShow views',
  'Telugu Content SlideShow Watch Analytics',
  'Guest Telugu Content SlideShow likes',
  'Guest Telugu Content SlideShow shares',
  'Guest Telugu Content SlideShow views',
  'Guest Telugu Content SlideShow Watch Analytics',
  'Telugu Content Poll likes',
  'Telugu Content Poll shares',
  'Telugu Content Poll views',
  'Telugu Content Poll Watch Analytics',
  'Guest Telugu Content Poll likes',
  'Guest Telugu Content Poll shares',
  'Guest Telugu Content Poll views',
  'Guest Telugu Content Poll Watch Analytics',
  'Hindi Content Story likes',
  'Hindi Content Story shares',
  'Hindi Content Story views',
  'Hindi Content Story Watch Analytics',
  'Guest Hindi Content Story likes',
  'Guest Hindi Content Story shares',
  'Guest Hindi Content Story views',
  'Guest Hindi Content Story Watch Analytics',
  'Hindi Content CoverStory likes',
  'Hindi Content CoverStory shares',
  'Hindi Content CoverStory views',
  'Hindi Content CoverStory Watch Analytics',
  'Guest Hindi Content CoverStory likes',
  'Guest Hindi Content CoverStory shares',
  'Guest Hindi Content CoverStory views',
  'Guest Hindi Content CoverStory Watch Analytics',
  'Hindi Content Mcq likes',
  'Hindi Content Mcq shares',
  'Hindi Content Mcq views',
  'Hindi Content Mcq Watch Analytics',
  'Guest Hindi Content Mcq likes',
  'Guest Hindi Content Mcq shares',
  'Guest Hindi Content Mcq views',
  'Guest Hindi Content Mcq Watch Analytics',
  'Hindi Content SlideShow likes',
  'Hindi Content SlideShow shares',
  'Hindi Content SlideShow views',
  'Hindi Content SlideShow Watch Analytics',
  'Guest Hindi Content SlideShow likes',
  'Guest Hindi Content SlideShow shares',
  'Guest Hindi Content SlideShow views',
  'Guest Hindi Content SlideShow Watch Analytics',
  'Hindi Content Poll likes',
  'Hindi Content Poll shares',
  'Hindi Content Poll views',
  'Hindi Content Poll Watch Analytics',
  'Guest Hindi Content Poll likes',
  'Guest Hindi Content Poll shares',
  'Guest Hindi Content Poll views',
  'Guest Hindi Content Poll Watch Analytics',
  'English Content Story likes',
  'English Content Story shares',
  'English Content Story views',
  'English Content Story Watch Analytics',
  'Guest English Content Story likes',
  'Guest English Content Story shares',
  'Guest English Content Story views',
  'Guest English Content Story Watch Analytics',
  'English Content ShortByte likes',
  'English Content ShortByte shares',
  'English Content ShortByte views',
  'Guest English Content ShortByte likes',
  'Guest English Content ShortByte shares',
  'Guest English Content ShortByte views',
  'English Content liveNews likes',
  'English Content liveNews shares',
  'English Content liveNews views',
  'Guest English Content liveNews likes',
  'Guest English Content liveNews shares',
  'Guest English Content liveNews views',
  'English Content CoverStory likes',
  'English Content CoverStory shares',
  'English Content CoverStory views',
  'English Content CoverStory Watch Analytics',
  'Guest English Content CoverStory likes',
  'Guest English Content CoverStory shares',
  'Guest English Content CoverStory views',
  'Guest English Content CoverStory Watch Analytics',
  'English Content Mcq likes',
  'English Content Mcq shares',
  'English Content Mcq views',
  'English Content Mcq Watch Analytics',
  'Guest English Content Mcq likes',
  'Guest English Content Mcq shares',
  'Guest English Content Mcq views',
  'Guest English Content Mcq Watch Analytics',
  'English Content SlideShow likes',
  'English Content SlideShow shares',
  'English Content SlideShow views',
  'English Content SlideShow Watch Analytics',
  'Guest English Content SlideShow likes',
  'Guest English Content SlideShow shares',
  'Guest English Content SlideShow views',
  'Guest English Content SlideShow Watch Analytics',
  'English Content Poll likes',
  'English Content Poll shares',
  'English Content Poll views',
  'English Content Poll Watch Analytics',
  'Guest English Content Poll likes',
  'Guest English Content Poll shares',
  'Guest English Content Poll views',
  'Guest English Content Poll Watch Analytics',
  'Top Stories',
  'India',
  'Telangana',
  'AP',
  'World',
  'Business',
  'Technology',
  'Sports',
  'Lifestyle',
  'Careers',
  'Health',
  'Entertainment(English)',
  'Entertainment(Telugu)',
  'Telugu Movies',
  'BollyWood',
  'Travel',
  'Science',
  'Politics',
  'Day',
]
export const videoPlayCountersTeluguContentHeadings = [
  'Date',
  'No Of Articles Published',
  'Active Users',
  'Telugu Content Story likes',
  'Telugu Content Story shares',
  'Telugu Content Story views',
  'Telugu Content Story Watch Analytics',
  'Guest Telugu Content Story likes',
  'Guest Telugu Content Story shares',
  'Guest Telugu Content Story views',
  'Guest Telugu Content Story Watch Analytics',
  'Telugu Content ShortByte likes',
  'Telugu Content ShortByte shares',
  'Telugu Content ShortByte views',
  'Guest Telugu Content ShortByte likes',
  'Guest Telugu Content ShortByte shares',
  'Guest Telugu Content ShortByte views',
  'Telugu Content liveNews likes',
  'Telugu Content liveNews shares',
  'Telugu Content liveNews views',
  'Guest Telugu Content liveNews likes',
  'Guest Telugu Content liveNews shares',
  'Guest Telugu Content liveNews views',
  'Telugu Content CoverStory likes',
  'Telugu Content CoverStory shares',
  'Telugu Content CoverStory views',
  'Telugu Content CoverStory Watch Analytics',
  'Guest Telugu Content CoverStory likes',
  'Guest Telugu Content CoverStory shares',
  'Guest Telugu Content CoverStory views',
  'Guest Telugu Content CoverStory Watch Analytics',
  'Telugu Content Mcq likes',
  'Telugu Content Mcq shares',
  'Telugu Content Mcq views',
  'Telugu Content Mcq Watch Analytics',
  'Guest Telugu Content Mcq likes',
  'Guest Telugu Content Mcq shares',
  'Guest Telugu Content Mcq views',
  'Guest Telugu Content Mcq Watch Analytics',
  'Telugu Content SlideShow likes',
  'Telugu Content SlideShow shares',
  'Telugu Content SlideShow views',
  'Telugu Content SlideShow Watch Analytics',
  'Guest Telugu Content SlideShow likes',
  'Guest Telugu Content SlideShow shares',
  'Guest Telugu Content SlideShow views',
  'Guest Telugu Content SlideShow Watch Analytics',
  'Telugu Content Poll likes',
  'Telugu Content Poll shares',
  'Telugu Content Poll views',
  'Telugu Content Poll Watch Analytics',
  'Guest Telugu Content Poll likes',
  'Guest Telugu Content Poll shares',
  'Guest Telugu Content Poll views',
  'Guest Telugu Content Poll Watch Analytics',
  'Top Stories',
  'India',
  'Telangana',
  'AP',
  'World',
  'Business',
  'Technology',
  'Sports',
  'Lifestyle',
  'Careers',
  'Health',
  'Entertainment(English)',
  'Entertainment(Telugu)',
  'Telugu Movies',
  'BollyWood',
  'Travel',
  'Science',
  'Politics',
  'Day',
]
export const videoPlayCountersHindiContentHeadings = [
  'Date',
  'No Of Articles Published',
  'Active Users',
  'Hindi Content Story likes',
  'Hindi Content Story shares',
  'Hindi Content Story views',
  'Hindi Content Story Watch Analytics',
  'Guest Hindi Content Story likes',
  'Guest Hindi Content Story shares',
  'Guest Hindi Content Story views',
  'Guest Hindi Content Story Watch Analytics',
  'Hindi Content CoverStory likes',
  'Hindi Content CoverStory shares',
  'Hindi Content CoverStory views',
  'Hindi Content CoverStory Watch Analytics',
  'Guest Hindi Content CoverStory likes',
  'Guest Hindi Content CoverStory shares',
  'Guest Hindi Content CoverStory views',
  'Guest Hindi Content CoverStory Watch Analytics',
  'Hindi Content Mcq likes',
  'Hindi Content Mcq shares',
  'Hindi Content Mcq views',
  'Hindi Content Mcq Watch Analytics',
  'Guest Hindi Content Mcq likes',
  'Guest Hindi Content Mcq shares',
  'Guest Hindi Content Mcq views',
  'Guest Hindi Content Mcq Watch Analytics',
  'Hindi Content SlideShow likes',
  'Hindi Content SlideShow shares',
  'Hindi Content SlideShow views',
  'Hindi Content SlideShow Watch Analytics',
  'Guest Hindi Content SlideShow likes',
  'Guest Hindi Content SlideShow shares',
  'Guest Hindi Content SlideShow views',
  'Guest Hindi Content SlideShow Watch Analytics',
  'Hindi Content Poll likes',
  'Hindi Content Poll shares',
  'Hindi Content Poll views',
  'Hindi Content Poll Watch Analytics',
  'Guest Hindi Content Poll likes',
  'Guest Hindi Content Poll shares',
  'Guest Hindi Content Poll views',
  'Guest Hindi Content Poll Watch Analytics',
  'Top Stories',
  'India',
  'Telangana',
  'AP',
  'World',
  'Business',
  'Technology',
  'Sports',
  'Lifestyle',
  'Careers',
  'Health',
  'Entertainment(English)',
  'Entertainment(Telugu)',
  'Telugu Movies',
  'BollyWood',
  'Travel',
  'Science',
  'Politics',
  'Day',
]
export const videoPlayCountersEnglishContentHeadings = [
  'Date',
  'No Of Articles Published',
  'Active Users',
  'English Content Story likes',
  'English Content Story shares',
  'English Content Story views',
  'English Content Story Watch Analytics',
  'Guest English Content Story likes',
  'Guest English Content Story shares',
  'Guest English Content Story views',
  'Guest English Content Story Watch Analytics',
  'English Content ShortByte likes',
  'English Content ShortByte shares',
  'English Content ShortByte views',
  'Guest English Content ShortByte likes',
  'Guest English Content ShortByte shares',
  'Guest English Content ShortByte views',
  'English Content liveNews likes',
  'English Content liveNews shares',
  'English Content liveNews views',
  'Guest English Content liveNews likes',
  'Guest English Content liveNews shares',
  'Guest English Content liveNews views',
  'English Content CoverStory likes',
  'English Content CoverStory shares',
  'English Content CoverStory views',
  'English Content CoverStory Watch Analytics',
  'Guest English Content CoverStory likes',
  'Guest English Content CoverStory shares',
  'Guest English Content CoverStory views',
  'Guest English Content CoverStory Watch Analytics',
  'English Content Mcq likes',
  'English Content Mcq shares',
  'English Content Mcq views',
  'English Content Mcq Watch Analytics',
  'Guest English Content Mcq likes',
  'Guest English Content Mcq shares',
  'Guest English Content Mcq views',
  'Guest English Content Mcq Watch Analytics',
  'English Content SlideShow likes',
  'English Content SlideShow shares',
  'English Content SlideShow views',
  'English Content SlideShow Watch Analytics',
  'Guest English Content SlideShow likes',
  'Guest English Content SlideShow shares',
  'Guest English Content SlideShow views',
  'Guest English Content SlideShow Watch Analytics',
  'English Content Poll likes',
  'English Content Poll shares',
  'English Content Poll views',
  'English Content Poll Watch Analytics',
  'Guest English Content Poll likes',
  'Guest English Content Poll shares',
  'Guest English Content Poll views',
  'Guest English Content Poll Watch Analytics',
  'Top Stories',
  'India',
  'Telangana',
  'AP',
  'World',
  'Business',
  'Technology',
  'Sports',
  'Lifestyle',
  'Careers',
  'Health',
  'Entertainment(English)',
  'Entertainment(Telugu)',
  'Telugu Movies',
  'BollyWood',
  'Travel',
  'Science',
  'Politics',
  'Day',
]
export const videoPlayCountersVideoHeadings = [
  'Date',
  'Telugu Video likes',
  'Telugu Video shares',
  'Telugu Video downloads',
  'Telugu Video views',
  'Telugu Video follows',
  'Guest Telugu Video likes',
  'Guest Telugu Video shares',
  'Guest Telugu Video downloads',
  'Guest Telugu Video views',
  'Guest Telugu Video follows',
  'Hindi Video likes',
  'Hindi Video shares',
  'Hindi Video downloads',
  'Hindi Video views',
  'Hindi Video follows',
  'Guest Hindi Video likes',
  'Guest Hindi Video shares',
  'Guest Hindi Video downloads',
  'Guest Hindi Video views',
  'Guest Hindi Video follows',
  'English Video likes',
  'English Video shares',
  'English Video downloads',
  'English Video views',
  'English Video follows',
  'Guest English Video likes',
  'Guest English Video shares',
  'Guest English Video downloads',
  'Guest English Video views',
  'Guest English Video follows',
  'OnlyMusic Video likes',
  'OnlyMusic Video shares',
  'OnlyMusic Video downloads',
  'OnlyMusic Video views',
  'OnlyMusic Video follows',
  'Guest OnlyMusic Video likes',
  'Guest OnlyMusic Video shares',
  'Guest OnlyMusic Video downloads',
  'Guest OnlyMusic Video views',
  'Guest OnlyMusic Video follows',
  'Hyderabadi Video likes',
  'Hyderabadi Video shares',
  'Hyderabadi Video downloads',
  'Hyderabadi Video views',
  'Hyderabadi Video follows',
  'Guest Hyderabadi Video likes',
  'Guest Hyderabadi Video shares',
  'Guest Hyderabadi Video downloads',
  'Guest Hyderabadi Video views',
  'Guest Hyderabadi Video follows',
  'Day',
]
export const videoPlayCountersteluguVideoHeadings = [
  'Date',
  'Telugu Video likes',
  'Telugu Video shares',
  'Telugu Video downloads',
  'Telugu Video views',
  'Telugu Video follows',
  'Guest Telugu Video likes',
  'Guest Telugu Video shares',
  'Guest Telugu Video downloads',
  'Guest Telugu Video views',
  'Guest Telugu Video follows',
  'Day',
]
export const videoPlayCountersteluguContentVideoHeadings = [
  'Date',
  'Telugu Content Videos likes',
  'Telugu Content Videos shares',
  'Telugu Content Videos views',
  'Guest Telugu Content Videos likes',
  'Guest Telugu Content Videos shares',
  'Guest Telugu Content Videos views',
  'Day',
]
export const videoPlayCountersenglishContentVideoHeadings = [
  'Date',
  'English Content Videos likes',
  'English Content Videos shares',
  'English Content Videos views',
  'Guest English Content Videos likes',
  'Guest English Content Videos shares',
  'Guest English Content Videos views',
  'Day',
]
export const videoPlayCountershindiVideoHeadings = [
  'Date',
  'Hindi Video likes',
  'Hindi Video shares',
  'Hindi Video downloads',
  'Hindi Video views',
  'Hindi Video follows',
  'Guest Hindi Video likes',
  'Guest Hindi Video shares',
  'Guest Hindi Video downloads',
  'Guest Hindi Video views',
  'Guest Hindi Video follows',
  'Day',
]
export const videoPlayCounterslocationContentHeadings = [
  'Date',
  'State',
  'District',
  'ContentType',
  'Likes',
  'Views',
  'Shares',
  'Watch Analytics',
  'Day',
]
export const videoPlayCounterslocationVideoHeadings = [
  'Date',
  'State',
  'District',
  'Likes',
  'Views',
  'Shares',
  'Downloads',
  'Day',
]
export const videoPlayCountersloginHeadings = [
  'Date',
  'State',
  'District',
  'Logins',
  'userType',
  'Day',
]
export const videoPlayCountersfeedTypeOptions = [
  {
    label: 'Content',
    value: 'Content',
    id: 0,
  },
  {
    label: 'Videos',
    value: 'Videos',
    id: 1,
  },
  {
    label: 'Login',
    value: 'Login',
    id: 2,
  },
  {
    label: 'Jobs',
    value: 'Jobs',
    id: 3,
  },
]
export const videoPlayCounterslanguageOptions = [
  {
    label: 'English',
    value: 'En',
    id: 0,
  },
  {
    label: 'Telugu',
    value: 'Te',
    id: 1,
  },
  {
    label: 'Hindi',
    value: 'Hi',
    id: 2,
  },
]
export const videoPlayCountersTGLocations = [
  {
    stateCodec: 'TG',
    district: 'All',
    label: 'All',
  },
]
export const videoPlayCountersAPLocations = [
  {
    stateCodec: 'AP',
    district: 'All',
    label: 'All',
  },
]
export const videoPlayCountersOtherOptions = [
  {
    stateCodec: 'Others',
    district: 'None',
    label: 'None',
  },
]
export const PNCountersHeadings = [
  'ContentID',
  'ContentTitle',
  'Pn Title',
  'PN Description',
  'PNOpenedCount',
  'SentPNTo',
  'Type',
  'PNSlot',
  'PNHour',
  'ContentCategory1',
  'ContentCategory2',
  'ContentCategory3',
  'ContentLanguage',
  'CreatorUUID',
  'CreatorHandle',
  'VideoID',
  // 'Time',
  'Day',
  'DateTime',
]
export const weekdays = [
  'None',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]
export const slots = ['None', '6AM-10AM', '10AM-1PM', '1PM-4PM', '4PM-7PM', '7PM-10PM', '10PM-6AM']
export const creatorAnalyticsHeadings = [
  'Num',
  'Creator Name',
  'Creator Handle',
  'Total Created',
  'Total Published',
  'Telugu Created ',
  'Hindi Created ',
  'English Created ',
  'Telugu Published',
  'Hindi Published',
  'English Published',
  'Profile Pic ',
  'Creator UUID',
  'Created Date',
]
export const referralUserSignupsHeadings = [
  'Id',
  'Reg User App InstallTime',
  'Reg User MobileNumber',
  'Reg User Name',
  'Reg User Handle',
  'Referred By UUID',
  'Referred By User MobileNumber',
  'Referred By UserName',
  'Referred By UserHandle',
]
export const usersignupsHeadings = [
  'Num',
  'Registered User Name',
  'Registered User Handle',
  'Registered User Mobile Number',
  'Luckydraw URL',
  'Location',
  'User First Registration Date',
]
export const unPublishedContentsHeadings = [
  'Num',
  'Actions',
  'Created Date',
  'WP Preview URL',
  'Scheduled',
  'Thumbnail',
  'Title',
  'Description',
  'Creator Name',
  'Creator Handle',
  'Likes',
  'Views',
  'Shares',
  'Comments',
  'Created From',
  'ContentID',
  'ContentType',
  'Main Category',
  'Archived',
  'Content Languages',
  'Approved Languages',
  'Target Areas',
  'Scheduled Date',
  'Published Date',
]
export const publishedContentsHeadings = [
  'Num',
  'Actions',
  'Created Date',
  'Published Date',
  'WP Preview URL',
  'Thumbnail',
  'Title',
  'Description',
  'Creator Name',
  'Created Handle',
  'Poll Options',
  'Polled Count',
  'Points',
  'Likes',
  'Views',
  'Shares',
  'Comments',
  'Created From',
  'Scheduled',
  'Scheduled Date',
  'ContentID',
  'ContentType',
  'Main Category',
  'Archived',
  'Content Languages',
  'Approved Languages',
  'Target Areas',
]
export const coverStoryTypes = [
  {
    item: 'Flip To Story',
    id: 1,
  },
  {
    item: 'Only Cover',
    id: 2,
  },
  {
    item: 'InApp Browser',
    id: 3,
  },
]
export const autoExpireOptions = [
  {
    value: 'None',
    days: 0,
    id: 1,
  },
  {
    value: '4 Hours',
    hours: 4,
    id: 2,
  },
  {
    value: '8 Hours',
    hours: 8,
    id: 3,
  },
  {
    value: '12 Hours',
    hours: 12,
    id: 4,
  },
  {
    value: '1 Day',
    days: 1,
    id: 5,
  },
  {
    value: '3 Days',
    days: 3,

    id: 6,
  },
  {
    value: '1 Week',
    days: 7,

    id: 7,
  },
  {
    value: '1 Month',
    days: 30,

    id: 8,
  },
]

export const creatorPointsReportHeadings = [
  'Creator Name',
  'Creator Handle',
  'Creator Points',
  'Creator Like Points',
  'Creator Bookmark Points',
  'Creator Pn Opens Points',
  'Creator Extra Articles Points',
  'Creator Total Likes',
  'Creator Total Bookmarks',
  'Creator Total Pn Opens',
  'Creator Total Contents Published',
  'Planner Points',
  'Planner Like Points',
  'Planner Bookmark Points',
  'Planner Pn Opens Points',
  'Planner Extra Articles Points',
  'Planner Total Likes',
  'Planner Total Bookmarks',
  'Planner Total Pn Opens',
  'Planner Total Contents Published',
  'Creator UUID',
]
export const jobListHeadings = [
  'Num',
  'Actions',
  'Created Date',
  'Company Logo',
  'Title',
  'Description',
  'Job Language',
  'Details',
  'Requirements',
  'Company Name',
  'About Company',
  'Company Contact details',
  'Company Address',
  'Content Main Details',
  'Content ID',
  // 'Created From',
  // 'ContentID',
  // 'Archived',

  // 'Approved Languages',
  // 'Target Areas',
  // 'Scheduled Date',
  // 'Published Date',
]
export const jobListHeadings1 = [
  'Num',
  'Actions',
  'Created Date',
  'Published Date',
  'Job Title',
  'Job Description',
  'Job Language',
  'Created By',
  'Published By',
  'Experience',
  'Salary',
  'Location',
  'No of Openings',
  'Qualifications',
  'Skills',
  'Content ID',
  // 'Created From',
  // 'ContentID',
  // 'Archived',

  // 'Approved Languages',
  // 'Target Areas',
  // 'Scheduled Date',
  // 'Published Date',
]
export const MatchData = [
  {
    key: 'c__board__bcci__b13f0',
    code: 'BCCI',
    name: 'Board of Control for Cricket in India',
  },
  {
    key: 'c__board__icc__c2ab7ee61',
    code: 'ICC',
    name: 'International Cricket Council',
  },
]
export const AboutEnTe = [
  { label: 'about_En', value: 'none' },
  { label: 'about_Te', value: '1' },
]
